import script from "./EditableTableColumn.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditableTableColumn.vue?vue&type=script&lang=ts&setup=true"

import "./EditableTableColumn.vue?vue&type=style&index=0&id=47980424&lang=scss&scoped=true"

import exportComponent from "/Users/lyon/Desktop/Work s2j/app-rentalcar-project/admin-v3 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47980424"]])

export default __exports__